import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const Title = styled.h1`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-weight: 500;
    color: ${colors.dark2};
    padding: 20px 20px 26px;
    font-size: 20px;
    line-height: 30px;
    span {
        color: ${colors.dark2};
        font-size: 16px;
        font-weight: 300;
    }
    @media screen and (max-width: 1919px) {
        font-size: 20px;
        padding: 20px 20px 26px;
        line-height: 30px;
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        padding: 20px 20px 26px;
        font-size: 20px;
        line-height: 20px;
  }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        padding: 20px 20px 26px;
        font-size: 20px;
        line-height: 20px;
  }
`;

export const BoxTitle = styled.div`
    background-color: ${colors.light};
    padding: 0 0;
    border-radius: 8px;
    margin-top: 32px;
    @media screen and (max-width: ${ScreenSize.tablet}px) {
       margin-top: 0;
  }
`;
